import styled, { css } from 'styled-components';

const storeSpecialBannerStyle = css`
  .banner-body {
    display: flex;
    flex-direction: column;
    justify-content: center;

    align-items: center;
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-direction: row;
      gap: 10px;
    }
  }

  .banner-heading {
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    font-variant: all-small-caps;
    letter-spacing: 0.28px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
      letter-spacing: 0.24px;
    }
  }

  .banner-title {
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%; /* 30px */
    letter-spacing: 0.8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 15px;
      font-weight: 700;
    }
  }

  .terms-link {
    color: ${(props) => props.FontColor || `#ffffff`};
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18px */
    letter-spacing: 0.48px;
    text-decoration-line: underline;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 10px;
      letter-spacing: 0.4px;
      text-decoration-line: underline;
    }
  }
`;

// Define the styled component
export const StyledStoreDetailBanner = styled.div`
  background-color: ${(props) => props.BannerColor || `#265851`};
  padding: 20px;
  text-align: center;
  color: ${(props) => props.FontColor || `#ffffff`};

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: 32px;
  }
`;

export default storeSpecialBannerStyle;
